import { useDispatch, useSelector } from "react-redux";
import { downloadBankGuaranteesReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useBankGuaranteesReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.clearing.bankguarantees.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadBankGuaranteesReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
